import { Injectable } from '@angular/core';
import { User } from '../model/user';
import { CookieService } from 'ngx-cookie-service';
import { of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ScopeService } from './scope.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  Users: User[] = [
    {
      id: 1,
      email: 'john@email.com',
      password: 'passWord12345',
      accessTokens: 'abc12345',
      archived: false,
      profile: null,
      roleId: '1',
      role: null,
      tokens: [],
      clients: null,
      merchants: null,
      createdAt: new Date(),
      updatedAt: new Date(),
      archivedAt: null,
      fullName: '',
      phone: '',
      status: '',
      roleName: 'Admin',
      userClasses: [],
      merchantGroups: [],
    },
  ];

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private scope: ScopeService
  ) { }

  login(email: string, password: string, remember: boolean) {
    return this.http
      .post('auth/signin', {
        email,
        password,
        remember,
      })
      .pipe(
        tap((res: any) => {
          if (res && res.id && res.token) {
            const expiresAt = Date.now() + 4 * 60 * 60 * 1000;
            localStorage.setItem('expiresAt', expiresAt.toString());
            this.cookieService.set('token', res.token, {
              expires: remember ? 30 : 1,
              path: '/',
              secure: true,
              sameSite: 'Strict',
            });
            this.cookieService.set('fdIdAccessToken', res.fdIdAccessToken, {
              expires: remember ? 30 : 1,
              path: '/',
              secure: true,
              sameSite: 'Strict',
            });
            this.scope.Scope = res?.scopes
            this.scope.Scope.push({
              "resource": "settings",
              "actions": [
                "create",
                "read",
                "update",
                "delete"
              ]
            }, {
              "resource": "profile",
              "actions": [
                "create",
                "read",
                "update",
                "delete"
              ]
            });
          }
          return res;
        })
      );
  }

  loggedIn = () => {
    return this.cookieService.check('token');
  };

  forgotPassword(email: string) {
    return this.http.post('auth/forgot-password', { email: email });
  }

  getUserDetailsByToken(token: string) {
    var user = this.Users.filter((x) => x.accessTokens == token);
    if (user.length > 0) {
      return of(this.Users[0]);
    } else {
      return of(null);
    }
  }

  changePassword(email: string, password: string) {
    return of((email && password) ?? true);
  }

  resetPassword(token: string, password: string) {
    return this.http.post('auth/reset-password', {
      token: token,
      password: password,
    });
  }

  verifyToken(token: string) {
    return this.http.post('auth/verify-token', { token: token });
  }

  // Sets session directly from a token provided by the WooCommerce plugin (no API call)
  setPluginSession(token: string) {
    const expiresAt = Date.now() + 4 * 60 * 60 * 1000;
    localStorage.setItem('expiresAt', expiresAt.toString());

    this.cookieService.set('token', token, {
      expires: 1,
      path: '/',
      secure: true,
      sameSite: 'None',
    });
  }


  // password validators
  specialCharPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      var regex = /(?=.*?[#?!@$%^&*-])/g;
      return regex.test(control.value) ? null : { specialCharacter: true };
    };
  }

  capitalLetterPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      var regex = /[A-Z]/g;
      return regex.test(control.value) ? null : { capitalLetter: true };
    };
  }

  smallLetterPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      var regex = /[a-z]/g;
      return regex.test(control.value) ? null : { smallLetter: true };
    };
  }

  numberPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      var regex = /[0-9]/g;
      return regex.test(control.value) ? null : { number: true };
    };
  }
}
